import { generatePath } from 'react-router-dom';
import { FULL_REPORT_ROUTER_URL } from '../../../router';
/** Builds the interval route URL that preserves the current chart selection. */
export var buildIntervalUrl = function (basePlanId, state, dateStr) {
  var params = new URLSearchParams();
  params.set('selectedDate', dateStr);
  if (state === null || state === void 0 ? void 0 : state.uniqueId) params.set('uniqueId', state.uniqueId);
  if ((state === null || state === void 0 ? void 0 : state.month) !== undefined && state.month !== 0) params.set('month', "".concat(state.month));
  if ((state === null || state === void 0 ? void 0 : state.chartQueueId) !== undefined) params.set('chartQueueId', "".concat(state.chartQueueId));
  if ((state === null || state === void 0 ? void 0 : state.chartLobId) !== undefined) params.set('chartLobId', "".concat(state.chartLobId));
  var query = params.toString();
  return "".concat(generatePath(FULL_REPORT_ROUTER_URL.Interval, {
    basePlanId: basePlanId
  })).concat(query ? '?' + query : '');
};
export var updateUniqueIdSearchParam = function (searchParams, uniqueId) {
  var params = new URLSearchParams(searchParams);
  params.set('uniqueId', uniqueId);
  return params;
};